import { render, staticRenderFns } from "./SiteSlider.vue?vue&type=template&id=2fb9d3b6"
import script from "./SiteSlider.vue?vue&type=script&lang=js"
export * from "./SiteSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports